import Product from '../../../domains/Product/Product'

export const FREE_GIFT = 'FREE_GIFT'
export const MINIMUM_CART_VALUE = 200.0
export const FREE_TOTE_SHOPIFY_ID = 7899207303338
export const KERRY = 'KERRY'
export const FREE_TOTE_VARIANT_ID = 45236291698858
export const FREE_TOTE_HANDLE = 'canvas-tote-bag'
export const FREE_TOTE_ID = 50097
export const FREE_TOTE_PRODUCT = [
  {
    id: 4726,
    type: 'Normal',
    shopifyProductId: 7899207303338,
    contentfulProductId: '6AuOt5yOUckad22QsQfWhK',
    title: 'Canvas Tote Bag ',
    slug: 'unisex/canvas-tote-bag',
    images: [
      {
        image: {
          url: '//images.ctfassets.net/afruo3gr1g6h/2DecKJJsK0dAgo9RikNlCq/38f0f28fcc9cb026bf59074ac1ed4e09/Quince_Tote_0133.jpg',
        },
      },
    ],
    productOptions: [
      {
        name: 'Color',
        displayName: 'Color',
        values: [
          {
            value: 'Natural',
            displayName: 'Natural',
            displayType: 'Color',
            hexCode: '#d4cec5',
            imgURL: null,
            addBorder: null,
          },
        ],
        displaySequence: 1,
        isHidden: false,
      },
      {
        name: 'Size',
        displayName: 'Size',
        values: [
          {
            value: 'One Size',
            displayName: 'One Size',
            displayType: 'Text',
          },
        ],
        displaySequence: 2,
        isHidden: true,
      },
    ],
    variants: [
      {
        id: 50097,
        shopifyVariantId: 45236291698858,
        shopifyProductId: 7899207303338,
        productId: 4726,
        price: '4.00',
        title: 'One Size / Natural',
        sku: 'LB65436',
        options: [
          {
            name: 'Color',
            value: 'Natural',
          },
          {
            name: 'Size',
            value: 'One Size',
          },
        ],
        customFields: [],
        status: 'DEVELOPMENT',
      },
    ],
    subClassId: 859,
  } as unknown as Product,
]
